var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgSmallChevronDown = function SvgSmallChevronDown(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Down' : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 12 12"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "2.49809783 3 1 4.39700133 6 9 11 4.39700133 9.50190217 3 6 6.22385021"
  })));
};
SvgSmallChevronDown = pure(SvgSmallChevronDown);
SvgSmallChevronDown.displayName = 'SvgSmallChevronDown';
export default SvgSmallChevronDown;